import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  TextField,
  InputAdornment,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import instance from "../utils/axiosInstance";

const Header = ({ user, setUser }) => {
  const navigate = useNavigate();
  const [keyword, setKeyword] = React.useState("");

  const handleLogout = async () => {
    try {
      await instance.post("/user/logout", {}, { withCredentials: true });
      setUser(null);
      navigate("/");
    } catch (error) {
      console.error("로그아웃 실패:", error);
    }
  };

  const handleSearch = () => {
    if (keyword.trim()) {
      navigate(`/nftlist/1?keyword=${encodeURIComponent(keyword.trim())}`);
    }
  };

  return (
    <AppBar position="sticky" elevation={0} sx={(theme) => ({
      backgroundColor: theme.palette.background.appbar,
      color: theme.palette.text.primary,
      borderBottom: "1px solid #ddd",
      px: 4,
      py: 1,
    })}>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between", maxWidth: 1400, mx: "auto", width: "100%" }}>
        <Box 
          component={Link} 
          to="/" 
          sx={{ 
            display: "flex", 
            alignItems: "center", 
            textDecoration: "none", 
            color: "inherit" 
          }}
        >
          <Box 
            component="img" 
            src="/logo_ver_3_low.png" 
            alt="ChainSpace Logo" 
            sx={{ 
              height: 30,
              width: "auto",
              objectFit: "contain",
              objectPosition: "left center",
              maxHeight: 50,
              maxWidth: 160,  
            }} 
          />
          
          <Box
            component="img"
            src="/logo_name.png" // public 폴더 안에 logo.png 저장
            alt="ChainSpace Logo"
            sx={{
              height: 43,        
              objectFit: "contain", 
            }}
          />
          </Box>

        <Box sx={{ mx: 4, flex: 1, maxWidth: 500 }}>
          <TextField
            fullWidth
            placeholder="검색어를 입력하세요"
            variant="outlined"
            size="small"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: "#888" }} />
                </InputAdornment>
              ),
              sx: (theme) => ({
                borderRadius: "30px",
                backgroundColor: theme.palette.background.appbar,
                "& input": { color: theme.palette.text.primary },
                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#ccc" },
                "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#999" },
              }),
            }}
          />
        </Box>

        <Box display="flex" gap={2} alignItems="center">
          {user ? (
            <>
              <Button component={Link} to="/profile">마이페이지</Button>
              <Button component={Link} to="/wallet">지갑</Button>
              <Button component={Link} to="/nftcreate">NFT 생성</Button>
              <Button onClick={handleLogout}>로그아웃</Button>
              <Typography variant="body2" color="text.secondary">{user.name}</Typography>
            </>
          ) : (
            <>
              <Button component={Link} to="/login">로그인</Button>
              <Button component={Link} to="/register">회원가입</Button>
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
